<script setup>
import { __, setFormFragmentValues, numbersType } from '@/utils';
import { inject, ref } from 'vue';
import IconSmartphone from '@components/icons/icon-smartphone.vue';

const { startActivation, showSuccessPage, registrationData } = inject('step');

const startActivationProcess = () => {
    showSuccessPage. value = false;
    startActivation.value = true;

    setFormFragmentValues({
        showSuccessPage: showSuccessPage.value,
        startActivation: startActivation.value
    });
}

const numberType = (isPorted) => isPorted ? __('Mobile subscription') : __('New line subscription');

const cleanLocalStorage = () => {
    // cleanup
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');
}

const message = ref(registrationSuccess.esim)
const messagePorted = ref(registrationSuccess.esim_ported)
const messageMixed= ref(registrationSuccess.esim_mixed)
</script>
<template>
    <div class="activation-header">
        <p>
            <span v-html="message" v-if="numbersType(registrationData.subscribers) === 'new_line'"></span>

            <span v-html="messagePorted" v-if="numbersType(registrationData.subscribers) === 'ported'"></span>

            <span v-html="messageMixed" v-if="numbersType(registrationData.subscribers) === 'mixed'"></span>
        </p>
    </div>
    <div class="number-boxes">
        <span class="number-box" v-for="number in registrationData.subscribers" :key="number.id">
            <div class="pill pill--iflex">
                <span class="pill__inner">
                    <span>
                        {{ number.msisdn }}
                    </span>
        
                    <div class="pill__icon">
                        <IconSmartphone />
                    </div><!-- /.pill__icon -->
                </span>
            </div>
            <div class="number-box__text">
                {{ numberType(number.is_ported) }}
            </div>
        </span>
    </div>
    <a href="/activation" class="btn link">
        {{ __('Continue') }}
    </a>
    <!-- <button type="button" class="btn link" @click="startActivationProcess">
        {{ __('Continue') }}
    </button> -->
    <div class="links">
        <a href="/activation" class="link">
            {{ __('Run through eSim activation') }}
        </a>
        <a href="/" class="link" @click="cleanLocalStorage">
            {{ __('Back to Home page') }}
        </a>
    </div>

</template>